import React, { useCallback, useEffect, useState } from 'react';

import { App, Button, Input, Spin, Switch, Typography } from 'antd';

import CustomMaskedInput from 'components/MaskedInput/index';
import { clearMoneyMask } from 'helpers/functions';
import customerService from 'v2/services/cutomer';
import { useUserStore } from 'v2/store/User';
import { ruleRunner, run } from 'validations/ruleRunner';
import { required, isEmail } from 'validations/rules';

import { Icon } from '@eduzz/ui-antd-theme';

const Validations = [ruleRunner('email', 'e-mail do co-afiliado', required, isEmail)];

interface IProps {
  coaffiliates: any;
  onChangeCheck: any;
  setReadyToSave: any;
  handleChangeCoAffiliates: any;
  public: any;
}

const Coaffiliates: React.FC<IProps> = ({
  coaffiliates: coaffiliatesProp,
  onChangeCheck,
  setReadyToSave,
  handleChangeCoAffiliates,
  public: isPublic
}) => {
  const { message } = App.useApp();
  const [coaffiliates, setCoaffiliates] = useState<any[]>(JSON.parse(JSON.stringify(coaffiliatesProp)));
  const [validationErrors, setValidationErrors] = useState<any>({});
  const [canDelete, setCanDelete] = useState(true);
  const [isSearching, setIsSearching] = useState(false);

  const { currentUserId } = useUserStore(({ user }) => ({ currentUserId: user.id }));

  useEffect(() => {
    setCoaffiliates(JSON.parse(JSON.stringify(coaffiliatesProp || [])));
  }, [coaffiliatesProp]);

  const onChangeEmail = useCallback(
    (e: any, index: any) => {
      const newCoaffiliates = [...coaffiliates];
      newCoaffiliates[index] = { ...newCoaffiliates[index], email: e.target.value };
      const errors = run({ email: e.target.value }, Validations);

      setCoaffiliates(newCoaffiliates);
      setValidationErrors(errors);
      setReadyToSave(false);
      setCanDelete(false);
    },
    [coaffiliates, setReadyToSave]
  );

  const onChangePercent = useCallback(
    (value: any, index: any) => {
      const newCoaffiliates = [...coaffiliates];
      newCoaffiliates[index] = { ...newCoaffiliates[index], percent: clearMoneyMask(value) };

      handleChangeCoAffiliates(newCoaffiliates);
      setCoaffiliates(newCoaffiliates);
    },
    [coaffiliates, handleChangeCoAffiliates]
  );

  const onSearchCustomerByEmail = useCallback(
    async (email: any, index: any) => {
      setIsSearching(true);
      const customerData = await customerService.loadCustomerByEmail(email);
      const found = customerData?.length > 0 ? customerData[0] : null;
      setCanDelete(true);
      setIsSearching(false);

      if (!found) {
        message.error('Insira um email válido!');
      } else {
        const newCoaffiliates = [...coaffiliates];

        if (newCoaffiliates[index]) {
          newCoaffiliates[index] = {
            ...newCoaffiliates[index],
            name: found.name,
            customer_id: found.id,
            disabled: currentUserId === found.id
          };
          handleChangeCoAffiliates(newCoaffiliates);
          setCoaffiliates(newCoaffiliates);
          setReadyToSave(true);
        }
      }
    },
    [coaffiliates, currentUserId, handleChangeCoAffiliates, message, setReadyToSave]
  );

  const deleteCoaffiliate = useCallback(
    (k: any) => {
      const filtered = coaffiliates.filter((_: any, index: any) => index !== k);
      handleChangeCoAffiliates(filtered);
      setCoaffiliates(filtered);
      setReadyToSave(true);
    },
    [coaffiliates, handleChangeCoAffiliates, setReadyToSave]
  );

  const handleChangePublic = useCallback(
    (checked: boolean) => {
      let newCoaffiliates = [...coaffiliates];

      if (checked) {
        newCoaffiliates.unshift({
          customer_id: 123456,
          percent: 0,
          name: 'Parceiros de Divulgação [Co-Afiliado]',
          email: null
        });
      } else {
        newCoaffiliates = newCoaffiliates.filter((value: any) => value.customer_id !== 123456);
      }

      onChangeCheck('public', { target: { checked } });
      handleChangeCoAffiliates(newCoaffiliates);
      setCoaffiliates(newCoaffiliates);
    },
    [coaffiliates, onChangeCheck, handleChangeCoAffiliates]
  );

  const addNewEmpty = useCallback(() => {
    const newCoaffiliates = [
      ...coaffiliates,
      {
        customer_id: 0,
        percent: 0,
        name: 'Busque seu co-afiliado',
        email: ''
      }
    ];
    handleChangeCoAffiliates(newCoaffiliates);
    setCoaffiliates(newCoaffiliates);
  }, [coaffiliates, handleChangeCoAffiliates]);

  const errorFor = useCallback(
    (field: any) => {
      return validationErrors[field] || '';
    },
    [validationErrors]
  );

  const isValid = useCallback(
    (field: any) => {
      return validationErrors[field] ? true : false;
    },
    [validationErrors]
  );

  const canAddCoaffiliate =
    coaffiliates.filter((item: any) => item.customer_id !== 123456 && currentUserId !== item.customer_id).length === 0;

  const coaffiliatesList = coaffiliates.map((item: any, index: any) => {
    if (item.customer_id === 123456) {
      return (
        <div
          key={'coafi' + index}
          className='grid grid-cols-12 items-center gap-3 rounded-(--uizz-antd-border-radius) bg-(--uizz-antd-color-fill-secondary) px-3 py-2'
        >
          <div className='col-span-9'>
            <Typography.Text>{item.name}</Typography.Text>
          </div>
          <div className='col-span-3'>
            <CustomMaskedInput
              id={`campaign-form-coaffiliate-percent-${index}`}
              mask='percent'
              size='small'
              startAdornment='%'
              fullWidth
              disableUnderline={true}
              value={item.percent}
              InputLabelProps={{
                shrink: true
              }}
              onChange={(value: any) => onChangePercent(value, index)}
            />
          </div>
        </div>
      );
    }

    if (currentUserId === item.customer_id && !item?.disabled) {
      return (
        <div key={'coafi' + index} className='grid grid-cols-1 items-end gap-3 md:grid-cols-12'>
          <div className='md:col-span-4'>
            <Typography.Text className='mb-1 block text-sm'>E-mail do co-afiliado</Typography.Text>
            <Input
              id={`campaign-form-coaffiliate-email-${index}`}
              size='small'
              disabled
              value={item.email}
              suffix={<Icon.Search size={14} />}
            />
          </div>
          <div className='md:col-span-4'>
            <Typography.Text className='mb-1 block text-sm'>Nome do co-afiliado</Typography.Text>
            <Input id={`campaign-form-coaffiliate-name-${index}`} size='small' disabled value={item.name} />
          </div>
          <div className='md:col-span-4'>
            <CustomMaskedInput
              id={`campaign-form-coaffiliate-percent-${index}`}
              mask='percent'
              size='small'
              label='Porcentagem'
              startAdornment='%'
              fullWidth
              disableUnderline={true}
              value={item.percent}
              InputLabelProps={{ shrink: true }}
              onChange={(value: any) => onChangePercent(value, index)}
            />
          </div>
        </div>
      );
    }

    return (
      <div key={'coafi' + index} className='grid grid-cols-1 items-end gap-3 md:grid-cols-12'>
        <div className='md:col-span-4'>
          <Typography.Text className='mb-1 block text-sm'>E-mail do co-afiliado</Typography.Text>
          <Input
            id={`campaign-form-coaffiliate-email-${index}`}
            size='small'
            disabled={isSearching}
            value={item.email}
            onBlur={() => onSearchCustomerByEmail(item.email, index)}
            onChange={(e: any) => onChangeEmail(e, index)}
            status={isValid('email') ? 'error' : undefined}
            suffix={
              isSearching ? (
                <Spin size='small' />
              ) : (
                <Button
                  id={`campaign-form-coaffiliate-search-${index}`}
                  type='text'
                  size='small'
                  disabled={isValid('email') || !item.email}
                  onClick={() => onSearchCustomerByEmail(item.email, index)}
                  icon={<Icon.Search size={14} />}
                />
              )
            }
          />
          {isValid('email') && (
            <Typography.Text className='text-xs text-(--uizz-antd-color-error)'>{errorFor('email')}</Typography.Text>
          )}
        </div>
        <div className='md:col-span-4'>
          <Typography.Text className='mb-1 block text-sm'>Nome do co-afiliado</Typography.Text>
          <Input id={`campaign-form-coaffiliate-name-${index}`} size='small' disabled value={item.name} />
        </div>
        <div className='md:col-span-3'>
          <CustomMaskedInput
            id={`campaign-form-coaffiliate-percent-${index}`}
            mask='percent'
            size='small'
            label='Porcentagem'
            startAdornment='%'
            fullWidth
            disableUnderline={true}
            value={item.percent}
            InputLabelProps={{ shrink: true }}
            onChange={(value: any) => onChangePercent(value, index)}
          />
        </div>
        <div className='flex items-end md:col-span-1'>
          <Button
            id={`campaign-form-coaffiliate-delete-${index}`}
            type='text'
            size='small'
            shape='circle'
            disabled={!canDelete}
            danger
            onClick={() => deleteCoaffiliate(index)}
            icon={<Icon.Trash2 size={14} />}
          />
        </div>
      </div>
    );
  });

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-wrap items-center justify-between gap-3'>
        <div className='flex items-center gap-2'>
          <Switch size='small' checked={isPublic} onChange={handleChangePublic} />
          <Typography.Text>Essa campanha é pública?</Typography.Text>
        </div>
        {canAddCoaffiliate && (
          <Button id='campaign-form-coaffiliate-add' type='primary' size='small' onClick={addNewEmpty}>
            Novo
          </Button>
        )}
      </div>
      <div className='flex flex-col gap-4'>{coaffiliatesList}</div>
    </div>
  );
};

export default Coaffiliates;
